/* Bhumi Gems display-only currency converter (v3, 2026-10-10).
   Converts the prices shown on the page for guidance; checkout always stays in USD.
   Rates: open.er-api.com (free, no key), cached 12 h in localStorage. */
(function () {
  var BASE = 'USD';
  var KEY_CUR = 'bh_currency', KEY_RATES = 'bh_rates_v1';
  var SYMBOLS = { USD: '$', INR: '₹', GBP: '£', EUR: '€', AUD: 'A$', CAD: 'C$', AED: 'AED ', SGD: 'S$', NZD: 'NZ$', CHF: 'CHF ', JPY: '¥', SAR: 'SAR ', HKD: 'HK$', SEK: 'kr ', NOK: 'kr ', DKK: 'kr ', ZAR: 'R ', MXN: 'MX$', BRL: 'R$' };
  var ZERO_DEC = { JPY: 1, INR: 1 };
  var PRICE_SEL = '.price-item, .totals__total-value, .cart-item__price-wrapper .price, .cart-item__details .price, .product-option dd .price, .quick-add__submit .price';
  var selects = document.querySelectorAll('[data-bh-currency-select]');
  if (!selects.length) return;
  var allowed = Array.prototype.map.call(selects[0].options, function (o) { return o.value; });
  var current = null;
  try { current = localStorage.getItem(KEY_CUR); } catch (e) {}
  if (!current || allowed.indexOf(current) < 0) current = BASE;
  var rates = null;

  function loadRates() {
    try {
      var c = JSON.parse(localStorage.getItem(KEY_RATES) || 'null');
      if (c && c.t && c.r && Date.now() - c.t < 12 * 3600 * 1000) { rates = c.r; return Promise.resolve(rates); }
    } catch (e) {}
    return fetch('https://open.er-api.com/v6/latest/' + BASE).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.rates) { rates = j.rates; try { localStorage.setItem(KEY_RATES, JSON.stringify({ t: Date.now(), r: rates })); } catch (e) {} }
      return rates;
    }).catch(function () { return null; });
  }
  function parseMoney(text) {
    var m = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var n = parseFloat(m);
    return isNaN(n) ? null : n;
  }
  function format(n, cur) {
    var dec = ZERO_DEC[cur] ? 0 : 2;
    var s = n.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return (SYMBOLS[cur] || cur + ' ') + s + ' ' + cur;
  }
  function convertAll() {
    var els = document.querySelectorAll(PRICE_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector(PRICE_SEL)) continue;
      var usd = el.getAttribute('data-bh-usd');
      if (usd === null) {
        var txt = el.textContent.trim();
        if (!/\$\s?[0-9]/.test(txt)) continue;
        var val = parseMoney(txt);
        if (val === null) continue;
        usd = String(val);
        el.setAttribute('data-bh-usd', usd);
        el.setAttribute('data-bh-orig', txt);
        el.setAttribute('data-bh-cur', BASE);
      }
      if (current === BASE || !rates || !rates[current]) {
        if (el.getAttribute('data-bh-cur') !== BASE) { el.textContent = el.getAttribute('data-bh-orig'); el.setAttribute('data-bh-cur', BASE); }
        continue;
      }
      if (el.getAttribute('data-bh-cur') === current) continue;
      el.textContent = '≈ ' + format(parseFloat(usd) * rates[current], current);
      el.setAttribute('data-bh-cur', current);
    }
    var notes = document.querySelectorAll('[data-bh-currency-note]');
    for (var k = 0; k < notes.length; k++) notes[k].hidden = current === BASE;
    document.documentElement.setAttribute('data-bh-currency', current);
  }
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(convertAll, 120); }

  Array.prototype.forEach.call(selects, function (s) {
    s.value = current;
    s.addEventListener('change', function () {
      current = allowed.indexOf(s.value) > -1 ? s.value : BASE;
      try { localStorage.setItem(KEY_CUR, current); } catch (e) {}
      Array.prototype.forEach.call(selects, function (o) { o.value = current; });
      if (current !== BASE && !rates) { loadRates().then(convertAll); } else { convertAll(); }
    });
  });
  if (current !== BASE) { loadRates().then(convertAll); } else { convertAll(); }
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].type === 'childList' && muts[i].addedNodes.length) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
